import * as BeerSlider from 'beerslider';

class CardAvantApres {
  constructor() {
    this._init();
  }

  _init() {
    const cards = document.querySelectorAll('.card-before-after__images');
    const options = {
      start: '70',
    };
    cards.forEach(card => {
      new BeerSlider(card as HTMLElement, options);
    });
  }

}

export const cardAvantApres = new CardAvantApres();
